import JerseysProxy from '@/proxies/Jerseys';
import JerseysTransform from '@/transforms/Jerseys';
import ProjectsProxy from '@/proxies/Projects';
import { JERSEY_OVERVIEW, JERSEY_BY_SEC, JERSEY_ISSUE_POINTS } from '@/constants';
import * as types from './mutation-types';

const getClosestFrame = (arr, goal) => arr.reduce((prev, { frame_id }) => {
  return (Math.abs(frame_id - goal) < Math.abs(prev - goal) ? frame_id : prev);
}, 0);

const getProxy = (type = '') => {
  switch (type) {
    case JERSEY_OVERVIEW: return 'getJerseysRandom';
    case JERSEY_BY_SEC: return 'getJerseysBySeconds';
    case JERSEY_ISSUE_POINTS: return 'getPotentialSplitPoints';
    default: return 'getJerseys';
  }
};

export default {
  getData({ dispatch }, payload) {
    Promise.all([
      dispatch('getJerseys', payload),
      dispatch('getNumbers', payload),
    ]);
  },
  async getJerseys({ commit, dispatch, getters }, payload = {}) {
    if (payload.id) {
      commit(types.SET_TRACK, payload);
    }
    commit(types.SET_LOADING, true);
    dispatch('setVisibilityModal', true);
    const proxy = new JerseysProxy();
    try {
      const job_id = payload.job_id || getters.job_id;
      const track_id = payload.track_id ?? getters.track_id ?? null;
      const page = payload.page || getters.page + 1;
      const view = payload.view || getters.view;
      const { detected_jerseys, points, total } = await proxy[getProxy(view)]({
        ...getters.options,
        job_id,
        page,
        track_id,
      });
      const jerseys = view !== JERSEY_ISSUE_POINTS ? detected_jerseys : points;
      const jerseysFormat = JerseysTransform.fetchCollection(jerseys);
      const items = [...getters.items, ...jerseysFormat].sort((a, b) => {
        if (getters.options.sort_direction === 'asc') {
          return a.frame_id - b.frame_id;
        }
        return b.frame_id - a.frame_id;
      });
      const selectedFrame = payload.selectedFrame ? getClosestFrame(jerseysFormat, payload.selectedFrame) : getters.selectedFrame;
      commit(types.SET_JERSEYS, {
        items,
        more: total > items.length,
        page,
        pageLoaded: [...getters.pageLoaded, page],
        selectedFrame,
        total,
        view,
      });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_jerseys', { root: true });
    } finally {
      commit(types.SET_LOADING, false);
    }
  },
  async getNumbers({ commit, dispatch }, payload = {}) {
    const proxy = new JerseysProxy();
    try {
      const { job_id, track_id } = payload;
      const { jersey_stats = {} } = await proxy.getNumbers({
        job_id,
        track_id,
      });

      const numbers = JerseysTransform.fetchScore(jersey_stats);
      commit(types.SET_NUMBERS, numbers);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_numbers', { root: true });
    }
  },
  setPage({ commit }, payload) {
    commit(types.SET_PAGE, payload);
  },
  async refreshJerseys({ dispatch }, payload) {
    const proxy = new ProjectsProxy();
    try {
      await proxy.refreshJerseys(payload);
      dispatch('notification/success', 'confirmationmessage.refresh_jerseys', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.refresh_jerseys', { root: true });
    }
  },
  reset({ commit }) {
    commit(types.RESET);
  },
  resetPartJerseys({ commit }) {
    commit(types.RESET_PART);
  },
  setJerseyType({ commit }, payload) {
    commit(types.SET_JERSEY_VIEW, payload);
  },
  setLoading({ commit }, payload) {
    commit(types.SET_LOADING, payload);
  },
  setSort({ commit, dispatch }, payload) {
    commit(types.SET_SORT, payload);
    dispatch('resetPartJerseys')
    dispatch('getJerseys');
  },
  setVisibilityModal({ commit }, payload) {
    commit(types.SET_VISIBILITY_MODAL, payload);
  },
};
